const list = {
  path: 'suggestion',
  component: resolve => require(['@/pages/admin/platform/suggestion'], resolve)
}

export default list
